/** saves Cards Type List
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardstype
*/
export const SAVE_CARDS_TYPE_LIST = (state, payload) => {
    state.cardsTypeList = payload.cardTypes
}

/** saves Meta Data
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardscorebankingrequestmetadata
*/
export const SAVE_METADATA_CARD_REQUEST = (state, payload) => {
    state.metaDataInfo = payload
}

/** saves Card Comissions
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardscommissions
*/
export const SAVE_CARD_COMISSIONS = (state, payload) => {
    state.cardComissions = payload
}

/** saves agencies provinces
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_agenciesprovinces
*/
export const SAVE_AGENCIES_PROVINCES = (state, payload) => {
    state.agenciesProvinces = payload.provinces
}

/** saves branches
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_branches
*/
export const SAVE_BRANCHES = (state, payload) => {
    state.branches = payload.page
}

/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}
